<template>
    
    <article>
        <h4 style="font-size: 24px; margin-bottom: 20px;">倒數計時器設定</h4>
        <!-- <h5 style="font-size: 18px;">倒數計時結束文字</h5>
        <div class="input-container">
            <section style="display: flex; flex-shrink: 1;">
                <label>									
                    倒數計時結束文字顏色
                </label>
                <v-text-field
                    @change="changeStatus( 'marketing_card','timer_off_text_color', timer_off_text_color)"
					v-model="timer_off_text_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','timer_off_text_color', timer_off_text_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="timer_off_text_color_menu"
                            :colorValue="timer_off_text_color"
                            @updateColorValue="timer_off_text_color = $event"
                            @updateColorMenu="timer_off_text_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','timer_off_text_color', timer_off_text_color)"
                        />
                    </template>    
                </v-text-field>
                <input
                    type="text"
                    v-model="timer_off_text_color"
                    @input="changeStatus( 'marketing_card','timer_off_text_color', timer_off_text_color)"
                >
                
            </section>
        </div>
        <div class="input-container">
            <section>
                <label>									
                    倒數計時結束文字
                </label>
                <input 
                    type="text" 
                    name=""
                    v-model="timer_off_text"
                    @input="changeStatus('marketing_card','timer_off_text', timer_off_text )"
                >

                <v-text-field
                    @change="changeStatus('marketing_card','timer_off_text', timer_off_text )"
					v-model="timer_off_text" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus('marketing_card','timer_off_text', timer_off_text )"
				>
                </v-text-field>
            </section>
        </div> -->
        <h5>描述文字</h5>
        <div class="input-container">
            <section>
                <label>									
                    開頭文字顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_text_color"
                    @change="changeStatus( 'marketing_card','count_down_text_color', count_down_text_color )"
                > -->
                <!-- <v-color-picker
                    v-model="count_down_text_color"
                    elevation="15"
                    @change="changeStatus( 'marketing_card','count_down_text_color', count_down_text_color )"
                ></v-color-picker> -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_text_color', count_down_text_color)"
					v-model="count_down_text_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_text_color', count_down_text_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_text_color_menu"
                            :colorValue="count_down_text_color"
                            @updateColorValue="count_down_text_color = $event"
                            @updateColorMenu="count_down_text_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_text_color', count_down_text_color)"
                        />
                    </template>    
                </v-text-field>
                <!-- <input
                    type="text"
                    v-model="count_down_text_color"
                    @input="changeStatus( 'marketing_card','count_down_text_color', count_down_text_color)"
                > -->
                
            </section>
        </div>					
        <div class="input-container">
            <section>
                <label>	開頭文字
                </label>
                <input 
                    @change="changeStatus( 'marketing_card','count_down_text', count_down_text )"
                    type="text"
                    v-model="count_down_text"
                    @input="changeStatus( 'marketing_card','count_down_text', count_down_text )"
                />
            </section>
        </div>
        <div class="input-container">
            <section>
                <label>									
                    結尾文字顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_text_end_color"
                    @change="changeStatus('marketing_card','count_down_text_end_color', count_down_text_end_color )"
                > -->
                <!-- <v-color-picker
                    v-model="count_down_text_end_color"
                    elevation="15"
                    @change="changeStatus('marketing_card','count_down_text_end_color', count_down_text_end_color )"
                ></v-color-picker> -->
                <!-- <input
                    type="text"
                    v-model="count_down_text_end_color"
                    @input="changeStatus( 'marketing_card','count_down_text_end_color', count_down_text_end_color)"
                >
                
                <ColorPicker
                    :colorMenu="count_down_text_end_color_menu"
                    :colorValue="count_down_text_end_color"
                    @updateColorValue="count_down_text_end_color = $event"
                    @updateColorMenu="count_down_text_end_color_menu = $event"
                    @changeStatusColorValue="changeStatus( 'marketing_card','count_down_text_end_color', count_down_text_end_color)"
                /> -->

                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_text_end_color', count_down_text_end_color)"
					v-model="count_down_text_end_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_text_end_color', count_down_text_end_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_text_end_color_menu"
                            :colorValue="count_down_text_end_color"
                            @updateColorValue="count_down_text_end_color = $event"
                            @updateColorMenu="count_down_text_end_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_text_end_color', count_down_text_end_color)"
                        />
                    </template>    
                </v-text-field>
                
            </section>
        </div>					
        <div class="input-container">
            <section>
                <label>	結尾文字
                </label>
                <input 
                    @change="changeStatus('marketing_card','count_down_text_end', count_down_text_end )"
                    type="text"
                    v-model="count_down_text_end"
                    @input="changeStatus('marketing_card','count_down_text_end', count_down_text_end )"
                />
            </section>
        </div>					
        <h5>樣式設定</h5>
        <div class="input-container">
            <section>
                <label>									
                    背景顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_text_bg_color"
                    @input="changeStatus('marketing_card','count_down_text_bg_color', count_down_text_bg_color )"
                > -->
                <!-- <v-color-picker
                    v-model="count_down_text_bg_color"
                    elevation="15"
                    @input="changeStatus('marketing_card','count_down_text_bg_color', count_down_text_bg_color )"
                ></v-color-picker> -->
                <!-- <input
                    type="text"
                    v-model="count_down_text_bg_color"
                    @input="changeStatus( 'marketing_card','count_down_text_bg_color', count_down_text_bg_color)"
                >
                <ColorPicker
                    :colorMenu="count_down_text_bg_color_menu"
                    :colorValue="count_down_text_bg_color"
                    @updateColorValue="count_down_text_bg_color = $event"
                    @updateColorMenu="count_down_text_bg_color_menu = $event"
                    @changeStatusColorValue="changeStatus( 'marketing_card','count_down_text_bg_color', count_down_text_bg_color)"
                /> -->

                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_text_bg_color', count_down_text_bg_color)"
					v-model="count_down_text_bg_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_text_bg_color', count_down_text_bg_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_text_bg_color_menu"
                            :colorValue="count_down_text_bg_color"
                            @updateColorValue="count_down_text_bg_color = $event"
                            @updateColorMenu="count_down_text_bg_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_text_bg_color', count_down_text_bg_color)"
                        />
                    </template>    
                </v-text-field>
                <span 
                    class="disable-color"	
                    v-on:click="changeStatus('marketing_card','count_down_text_bg_color', 'transparent' )"
                    
                    :class="{
                        label_active: count_down_text_bg_color === 'transparent'
                    }"
                >
                    <v-icon>
                        mdi-close-circle-outline
                    </v-icon>
                        不用顏色	
                </span>							
            </section>
        </div>
        <h5>日設定</h5>
        <div class="input-container" style="flex-direction: column;">
            <section class="mb-2">
                <label>	單位文字
                </label>
                <input 
                    @change="changeStatus('marketing_card','count_down_d_text', count_down_d_text )"
                    type="text"
                    v-model="count_down_d_text"
                    @input="changeStatus('marketing_card','count_down_d_text', count_down_d_text )"
                />
            </section>
            <section class="mb-2">
                <label>									
                    單位顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_d_text_color"
                    @input="changeStatus('marketing_card','count_down_d_text_color', count_down_d_text_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_d_text_color', count_down_d_text_color)"
					v-model="count_down_d_text_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_d_text_color', count_down_d_text_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_d_text_color_menu"
                            :colorValue="count_down_d_text_color"
                            @updateColorValue="count_down_d_text_color = $event"
                            @updateColorMenu="count_down_d_text_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_d_text_color', count_down_d_text_color)"
                        />
                    </template>    
                </v-text-field>
            </section>
            <section class="mb-2">
                <label>									
                    數字顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_d_value_color"
                    @input="changeStatus('marketing_card','count_down_d_value_color', count_down_d_value_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_d_value_color', count_down_d_value_color)"
					v-model="count_down_d_value_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_d_value_color', count_down_d_value_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_d_value_color_menu"
                            :colorValue="count_down_d_value_color"
                            @updateColorValue="count_down_d_value_color = $event"
                            @updateColorMenu="count_down_d_value_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_d_value_color', count_down_d_value_color)"
                        />
                    </template>    
                </v-text-field>
            </section>						
        </div>
        <h5>時設定</h5>
        <div class="input-container" style="flex-direction: column;">
            <section class="mb-2">
                <label>	單位文字
                </label>
                <input 
                    @change="changeStatus('marketing_card','count_down_h_text', count_down_h_text )"
                    type="text"
                    v-model="count_down_h_text"
                    @input="changeStatus('marketing_card','count_down_h_text', count_down_h_text )"
                />
            </section>
            <section class="mb-2"> 
                <label>									
                    單位顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_h_text_color"
                    @input="changeStatus('marketing_card','count_down_h_text_color', count_down_h_text_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_h_text_color', count_down_h_text_color)"
					v-model="count_down_h_text_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_h_text_color', count_down_h_text_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_h_text_color_menu"
                            :colorValue="count_down_h_text_color"
                            @updateColorValue="count_down_h_text_color = $event"
                            @updateColorMenu="count_down_h_text_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_h_text_color', count_down_h_text_color)"
                        />
                    </template>    
                </v-text-field>
            </section>
            <section class="mb-2">
                <label>									
                    數字顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_h_value_color"
                    @input="changeStatus('marketing_card','count_down_h_value_color', count_down_h_value_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_h_value_color', count_down_h_value_color)"
					v-model="count_down_h_value_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_h_value_color', count_down_h_value_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_h_value_color_menu"
                            :colorValue="count_down_h_value_color"
                            @updateColorValue="count_down_h_value_color = $event"
                            @updateColorMenu="count_down_h_value_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_h_value_color', count_down_h_value_color)"
                        />
                    </template>    
                </v-text-field>
            </section>						
        </div>
        <h5>分設定</h5>
        <div class="input-container" style="flex-direction: column;">
            <section class="mb-2">
                <label>	單位文字
                </label>
                <input 
                    @change="changeStatus('marketing_card','count_down_m_text', count_down_m_text )"
                    type="text"
                    v-model="count_down_m_text"
                    @input="changeStatus('marketing_card','count_down_m_text', count_down_m_text )"
                />
            </section>
            <section class="mb-2">
                <label>									
                    單位顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_m_text_color"
                    @change="changeStatus('marketing_card','count_down_m_text_color', count_down_m_text_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_m_text_color', count_down_m_text_color)"
					v-model="count_down_m_text_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_m_text_color', count_down_m_text_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_m_text_color_menu"
                            :colorValue="count_down_m_text_color"
                            @updateColorValue="count_down_m_text_color = $event"
                            @updateColorMenu="count_down_m_text_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_m_text_color', count_down_m_text_color)"
                        />
                    </template>    
                </v-text-field>
            </section>
            <section class="mb-2">
                <label>									
                    數字顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_m_value_color"
                    @change="changeStatus('marketing_card','count_down_m_value_color', count_down_m_value_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_m_value_color', count_down_m_value_color)"
					v-model="count_down_m_value_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_m_value_color', count_down_m_value_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_m_value_color_menu"
                            :colorValue="count_down_m_value_color"
                            @updateColorValue="count_down_m_value_color = $event"
                            @updateColorMenu="count_down_m_value_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_m_value_color', count_down_m_value_color)"
                        />
                    </template>    
                </v-text-field>
            </section>						
        </div>
        <h5>秒設定</h5>
        <div class="input-container" style="flex-direction: column;">
            <section class="mb-2">
                <label>	單位文字
                </label>
                <input 
                    @change="changeStatus('marketing_card','count_down_s_text', count_down_s_text )"
                    type="text"
                    v-model="count_down_s_text"
                    @input="changeStatus('marketing_card','count_down_s_text', count_down_s_text )"
                />
            </section>
            <section class="mb-2">
                <label>									
                    單位顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_s_text_color"
                    @change="changeStatus('marketing_card','count_down_s_text_color', count_down_s_text_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_s_text_color', count_down_s_text_color)"
					v-model="count_down_s_text_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_s_text_color', count_down_s_text_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_s_text_color_menu"
                            :colorValue="count_down_s_text_color"
                            @updateColorValue="count_down_s_text_color = $event"
                            @updateColorMenu="count_down_s_text_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_s_text_color', count_down_s_text_color)"
                        />
                    </template>    
                </v-text-field>
            </section>
            <section class="mb-2">
                <label>									
                    數字顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="count_down_s_value_color"
                    @change="changeStatus('marketing_card','count_down_s_value_color', count_down_s_value_color )"
                > -->
                <v-text-field
                    @change="changeStatus( 'marketing_card','count_down_s_value_color', count_down_s_value_color)"
					v-model="count_down_s_value_color" hide-details class="ma-0 pa-0" solo
                    @input="changeStatus( 'marketing_card','count_down_s_value_color', count_down_s_value_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="count_down_s_value_color_menu"
                            :colorValue="count_down_s_value_color"
                            @updateColorValue="count_down_s_value_color = $event"
                            @updateColorMenu="count_down_s_value_color_menu = $event"
                            @changeStatusColorValue="changeStatus( 'marketing_card','count_down_s_value_color', count_down_s_value_color)"
                        />
                    </template>    
                </v-text-field>
            </section>						
        </div>															
    </article>    
</template>

<script>

import { mapState,mapGetters } from 'vuex'

import ColorPicker from "@/components/Utils/ColorPicker.vue"

export default {
    props: {
        oldSettingData: Object,
        loadOldSettingData: Boolean,
        timeLineMode: String
    },
    name: "MarketingCardSettingTimeCountDown",
    components: {
        ColorPicker
    },
    data() {
        return{
            // 倒數計時結束後要顯示的文字內容
            timer_off_text: '活動已結束',

            // 倒數計時結束後要顯示的文字顏色
            timer_off_text_color: "#ff0f0f",

            /* 倒數計時說明文字 */
            count_down_text: "限時倒數",
            count_down_text_bg_color: "#ffb3be",
            count_down_text_color: "#ff0f0f",

            //結尾
            count_down_text_end: "！",
            count_down_text_end_color: "#ff0f0f",

            count_down_d_text: "日",
            count_down_d_text_color: "#FFFFFF",
            count_down_d_value_color: "#FFFFFF",

            count_down_h_text: "小時",
            count_down_h_text_color: "#FFFFFF",
            count_down_h_value_color: "#FFFFFF",

            count_down_m_text: "分",
            count_down_m_text_color: "#FFFFFF",
            count_down_m_value_color: "#FFFFFF",

            count_down_s_text: "秒",
            count_down_s_text_color: "#FFFFFF",
            count_down_s_value_color: "#FFFFFF",

            // 監聽它來判斷是否需要載入舊設定檔，會從父組件傳值進來
            load_old_setting_data: false,

            menu: false,

            timer_off_text_color_menu: false,
            count_down_text_color_menu: false,
            count_down_text_end_color_menu: false,
            count_down_text_bg_color_menu: false,
            count_down_d_text_color_menu: false,
            count_down_d_value_color_menu: false,
            count_down_h_text_color_menu: false,
            count_down_h_value_color_menu: false,
            count_down_m_text_color_menu: false,
            count_down_m_value_color_menu: false,
            count_down_s_text_color_menu: false,
            count_down_s_value_color_menu: false,

            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            }
        }
    },
    mounted() {
        console.log("yo MarketingCardSettingTimeCountDown");
        console.log(this.timer_off_text_color);
        if (this.load_old_setting_data) {
            this.loadOldMarketingCardSettingData()
        }
    },
    computed: {
        ...mapState(['marketing_card',]),
        ...mapGetters(['warmUpCardSetting','activityCardSetting','endUpCardSetting']),
        
    },
    methods: {
        changeStatus: async function(param_name,field_name, new_value){
            let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
            tmp[field_name] = new_value
            await this.$store.commit(param_name, tmp)
            console.log('after_commit', this.$store.getters[param_name])
            await this.$emit('save-time-line-setting')
        },
        swatchStyle() {
            return {
                backgroundColor: this.timer_off_text_color,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                border: this.timer_off_text_color.indexOf('FFFF') !== -1 ? '1px solid #CCC' : 'none',
                borderRadius: this.timer_off_text_color? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out'
            }
        },
        loadOldMarketingCardSettingData() {
            console.log(this.oldSettingData);
            
            console.log(this.timeLineMode);
            let origin_card_html = this.oldSettingData !== null ? this.oldSettingData['card_content'] : this[this.parseKey[this.timeLineMode]]['card_content']
            let card = this.$utils.createDomByHtmlString(origin_card_html)
            let text 
            let color
            let tmp_color
            /* 倒數計時器背景顏色 */
            color = card.getElementsByClassName('time_container')[0].style.backgroundColor
            if (color === 'transparent') {
                this.count_down_text_bg_color = 'transparent'
                this.marketing_card.count_down_text_bg_color = 'transparent'
            }
            else {
                tmp_color = this.$utils.rgbStingToArray(color);
                this.count_down_text_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2]))
                this.marketing_card.count_down_text_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2]))
            }

            /* 倒數計時器描述文字 */
            text = card.getElementsByClassName('t_description')[0].innerText.replace(/[\n\r]+|[\s]{2,}/g, '')
            this.count_down_text = text
            this.marketing_card.count_down_text = text
            
            /* 倒數計時器描述文字顏色 */
            color = card.getElementsByClassName('t_description')[0].style.color;
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2]))
            this.marketing_card.count_down_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2]))

            text = card.getElementsByClassName('t_description_end')[0].innerText.replace(/[\n\r]+|[\s]{2,}/g, '')
            this.count_down_text_end = text
            this.marketing_card.count_down_text_end = text
            color = card.getElementsByClassName('t_description_end')[0].style.color;				
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_text_end_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2]))
            this.marketing_card.count_down_text_end_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2]))

            /* 倒數計時器日單位文字 */
            text = card.getElementsByClassName('t_days_unit')[0].innerText.replace(/[\n\r]+|[\s]{2,}/g, '')
            this.count_down_d_text = text
            this.marketing_card.count_down_d_text = text

            /* 倒數計時器日單位文字顏色 */
            color = card.getElementsByClassName('t_days_unit')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_d_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()				
            this.marketing_card.count_down_d_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()					

            /* 倒數計時器日數字顏色 */
            color = card.getElementsByClassName('t_days')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_d_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
            this.marketing_card.count_down_d_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()

            /* 倒數計時器小時單位文字 */
            text = card.getElementsByClassName('t_hours_unit')[0].innerText.replace(/[\n\r]+|[\s]{2,}/g, '')
            this.count_down_h_text = text
            this.marketing_card.count_down_h_text = text

            /* 倒數計時器小時單位文字顏色 */
            color = card.getElementsByClassName('t_hours_unit')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_h_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
            this.marketing_card.count_down_h_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()

            /* 倒數計時器小時數字顏色 */
            color = card.getElementsByClassName('t_hours')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_h_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()				
            this.marketing_card.count_down_h_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()			

            /* 倒數計時器分單位文字 */
            text = card.getElementsByClassName('t_minutes_unit')[0].innerText.replace(/[\n\r]+|[\s]{2,}/g, '')
            this.count_down_m_text = text
            this.marketing_card.count_down_m_text = text

            /* 倒數計時器分單位文字顏色 */
            color = card.getElementsByClassName('t_minutes_unit')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_m_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()				
            this.marketing_card.count_down_m_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()			

            /* 倒數計時器分數字顏色 */
            color = card.getElementsByClassName('t_minutes')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color)
            this.count_down_m_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()			
            this.marketing_card.count_down_m_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()				

            /* 倒數計時器秒單位文字 */
            text = card.getElementsByClassName('t_seconds_unit')[0].innerText.replace(/[\n\r]+|[\s]{2,}/g, '')
            this.count_down_s_text = text
            this.marketing_card.count_down_s_text = text

            /* 倒數計時器秒單位文字顏色 */
            color = card.getElementsByClassName('t_seconds_unit')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_s_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()				
            this.marketing_card.count_down_s_text_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()				

            /* 倒數計時器秒數字顏色 */
            color = card.getElementsByClassName('t_seconds')[0].style.color
            tmp_color = this.$utils.rgbStingToArray(color);
            this.count_down_s_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()								
            this.marketing_card.count_down_s_value_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
        }
    },
    watch: {
        loadOldSettingData: {
            handler: function(newValue) {
                this.load_old_setting_data = newValue
            },
            immediate: true
        },
        load_old_setting_data: {
            handler: function(newValue) {
                if (newValue) {
                    console.log(this.oldSettingData);
                    let add_column = this.oldSettingData !== null ? JSON.parse(this.oldSettingData.add_column) : JSON.parse(this[this.parseKey[this.timeLineMode]]['add_column'])
                    console.log(add_column);
                    this.timer_off_text = add_column['timer_off_text']
                    this.timer_off_text_color = add_column['timer_off_text_color']

                    // this.count_down_text = add_column['timer_off_text_color']

                    
                    // this.discount_price_size = add_column['discount_price_size']
                    // this.discount_price_color = add_column['discount_price_color']
                    // this.discount_price = add_column['discount_price']
                    // this.product_text_size = add_column['product_text_size']
                    // this.product_text_color = add_column['product_text_color']
                    // this.product_text = add_column['product_text']
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
    .preview-hint-container > h4{
        display: flex;
        align-items: center;
        margin-top: 0.5em;

    }
    .preview-hint-container > h4 > i {
        margin-right: 0.5em;
    }
    .preview-container, .setting-container {
        display: flex;
        flex-direction: column;
    }
    .setting-container {
        width: 100%;
        overflow: hidden;
    }
    .setting-main {
        overflow: scroll;
    }
    .setting-main > article{
        background-color: #FFFFFF;
        border-bottom:1px #CCC solid;
        padding: 1em;
        overflow: scroll;
    }
    .setting-main > article:last-child {
        border-bottom: none;
    }
    .setting-main > article > h4 {
        padding-bottom:1em;
        font-weight: 600;
        font-size: 1.4em;
    }
    .setting-main > article > h5 {
        padding-bottom:1em;
        font-weight:500;
        font-size: 1.1em;
        display: flex;
    }
    .setting-main > article > h5 > i {
        color: #409aff;
        margin-right: 0.5em;
    }

    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .basic-setting-title {	
        display: flex;
    }
    .basic-setting-title > span {
        display: flex;
        align-items: center;
        font-size: 0.7em;
        color: #409aff;
        margin-left: 0.5em;
    }
    .basic-setting-title > span > i{

        font-size: 18px;
        margin-right: 5px;

    }
    .basic-setting-title > span > a{

        font-weight: 200;
        outline: none;
        text-decoration: none;
        color: #409aff;

    }
    .basic-setting-title > span > a:hover {
        text-decoration: underline;
    }
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
    }
    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        font-weight: 200;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }

    .disable_margin {
        margin: 0px;
    }

    .label_active {
        color: #ea8181;
    }

    .input-wrapper input[type="text"], .input-wrapper input[type="number"]  {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
</style>